// extracted by mini-css-extract-plugin
module.exports = {"pro-blog-post-details":"ProBlogPostDetails_pro-blog-post-details__S2Yu0","content":"ProBlogPostDetails_content__6HRRV","name":"ProBlogPostDetails_name__QX_Jv"};